module.exports = __webpack_public_path__ + "static/helado-iphone-3d7ef2d5d274c105073e6d19e985d78a.png";